<script lang="ts">
    import cn from 'classnames';

    import { globalStore } from '@components/stores';
    import { dialogStore } from '@components/ui/dialog';
    import LL from '@i18n/i18n-svelte';
    import icon from '@images/fail.svg';
    import { Button, ButtonTypes } from '@uikit/button';
    import { Font, FontTypes } from '@uikit/font';

    import s from './expired.module.css';

    const requestNewLink = () => {
        dialogStore.showResetPassword();
    };
</script>

<div class={cn(s.root)}>
    <div class={cn(s.dialogRoot, { [s.desktop]: $globalStore.isDesktopSite })}>
        <img src={icon} width="58" height="58" alt="Mail icon" />
        <Font tagName={FontTypes.TagName.h2} type={FontTypes.Type.h3} isBold className={cn(s.title)}
            >{$LL.dialogs.passwordRecoveryLinkExpired.title()}
        </Font>
        <Font tagName={FontTypes.TagName.p} type={FontTypes.Type.body} className={cn(s.subtitle)}
            >{$LL.dialogs.passwordRecoveryLinkExpired.subtitle()}
        </Font>
        <Button
            classes={cn(s.button)}
            color={ButtonTypes.Color.Secondary}
            on:click={requestNewLink}
        >
            {$LL.dialogs.passwordRecoveryLinkExpired.requestNewLinkBtn()}
        </Button>
    </div>
</div>
